import { Host, ApiAuth } from './config'

import axios from 'axios'
import iView from 'view-design'
import { getToken } from './tools'

export const baseUrl = (process.env.NODE_ENV === 'development' ? Host.dev : Host.pro)

class HttpRequest {
  constructor (baseUrl) {
    this.baseUrl = baseUrl
    this.lastRateLimitMessageAt = 0
  }

  showRateLimitMessage () {
    const now = Date.now()
    if (now - this.lastRateLimitMessageAt < 3000) return
    this.lastRateLimitMessageAt = now
    iView.Message.warning('请求过于频繁，请稍后再试')
  }

  interceptors (instance) {
    // 请求拦截
    instance.interceptors.request.use(config => {
      return config
    }, error => {
      return Promise.reject(error)
    })
    // 响应拦截
    instance.interceptors.response.use(res => {
      const { data, status } = res
      if (data.code < 0) {
        iView.Message.error(data.msg)
        throw new Error(data.msg)
      } else {
        return { data, status }
      }
    }, error => {
      if (error && error.response && error.response.status === 429) {
        this.showRateLimitMessage()
      }
      return Promise.reject(error)
    })
  }

  request (options) {
    const instance = axios.create()
    let token = getToken()
    if (token === false || !token) {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: ApiAuth
        }
      }, options)
    } else {
      options = Object.assign({
        baseURL: this.baseUrl,
        headers: {
          ApiAuth: token
        }
      }, options)
    }
    this.interceptors(instance)
    return instance(options)
  }
}

const api_axios = new HttpRequest(baseUrl)
export default api_axios
